var map = {
	"./burger_chicken.png": "453d",
	"./burger_deluxe.png": "3ac2",
	"./burger_veggie.png": "a101",
	"./desert_choco.png": "b23f",
	"./desert_cream.png": "6c80",
	"./desert_deluxe.png": "fcbf",
	"./pizza_bbq.png": "1d12",
	"./pizza_deluxe.png": "bc79",
	"./pizza_hawai.png": "d6b6",
	"./pizza_meat.png": "1080",
	"./pizza_pep.png": "3829",
	"./pizza_veggie.png": "45a5",
	"./salat_chicken.png": "9a79",
	"./salat_meat.png": "d461",
	"./salat_nuts.png": "1a31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fe";